/**
 * ============================================================================
 * PRODUCT ADD-ONS — single-select groups
 * ============================================================================
 * Companion to product-addons.js. Handles any group flagged
 * "Only one option can be chosen" in the metaobject, which renders as radios
 * instead of checkboxes.
 *
 * Native radios have two gaps this closes:
 *   - a chosen radio can't be un-chosen, so there's no way back to "none"
 *   - keyboard users can't clear one at all, hence the "Clear selection" button
 *
 * Both paths dispatch a bubbling 'change', which <product-addons> already
 * listens for, so the running total and cart payload stay correct without
 * this file needing to know anything about them.
 * ============================================================================
 */
(function () {
  'use strict';

  function notify(el) {
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncClear(group) {
    var clear = group.querySelector('[data-addons-clear]');
    if (clear) clear.hidden = !group.querySelector('[data-addon]:checked');
  }

  function init(group) {
    if (group._addonSingleReady) return;
    group._addonSingleReady = true;

    var radios = group.querySelectorAll('input[type="radio"][data-addon]');

    Array.prototype.forEach.call(radios, function (radio) {
      /* mousedown lands before the browser flips .checked, so stash the old state. */
      radio.addEventListener('mousedown', function () {
        radio._wasChecked = radio.checked;
      });

      radio.addEventListener('click', function () {
        if (radio._wasChecked) {
          radio.checked = false;
          notify(radio);
        }
        radio._wasChecked = false;
      });
    });

    var clear = group.querySelector('[data-addons-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        var checked = group.querySelector('[data-addon]:checked');
        if (!checked) return;
        Array.prototype.forEach.call(group.querySelectorAll('[data-addon]'), function (input) {
          input.checked = false;
        });
        notify(checked);
        syncClear(group);
      });
    }

    group.addEventListener('change', function () {
      syncClear(group);
    });

    syncClear(group);
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-addon-single]'), init);
  }

  /* The theme swaps product markup in place, so re-scan after it does. */
  document.addEventListener('DOMContentLoaded', scan);
  document.documentElement.addEventListener('product:rerendered', scan);
  document.documentElement.addEventListener('variant:changed', scan);

  scan();
})();
